import "./index.scss";

import { GeoJsonObject } from "geojson";
import { Map, divIcon, geoJson, map, marker } from "leaflet";
import React from "react";

import { useEffectOnce } from "../../hooks";
import { useAppStore } from "../../stores";

export default function Component({
	mapId,
	markers,
	polygons,
	onInit,
}: {
	mapId: string;
	markers?: { coordinates: [number, number]; popup?: string; status?: boolean }[];
	polygons?: {
		countryCode: string;
		geoJson?: GeoJsonObject;
		popup?: string;
	}[];
	onInit?: (map: Map) => void;
}) {
	const appStore = useAppStore((state) => state);

	const defaultIcon = divIcon({
		className: "marker-primary",
		iconSize: [24, 32],
		iconAnchor: [12, 32],
		html: '<i class="fa-solid fa-location-dot" style="color: #1d4d70"></i>',
	});

	useEffectOnce(() => {
		const initMap = map(mapId, {
			attributionControl: false,
			scrollWheelZoom: false,
			center: [41.205528, 74.779888],
			zoom: 6,
			minZoom: 4,
			maxZoom: 18,
			maxBounds: [
				[-90, -180],
				[90, 180],
			],
		});

		if (polygons) {
			polygons.map((p) => {
				if (p.geoJson == null) return;

				const geoJsonInstance = geoJson(p.geoJson, {
					style: {
						className: "polygon-primary",
						color: "#0B467880",
						fillColor: "#0B467880",
						weight: 2,
						opacity: 1,
					},
					onEachFeature: (feature, layer) => {
						layer.on({
							popupopen: (e) => {
								const el = e.target.getElement();
								el.classList.add("active");
							},
							popupclose: (e) => {
								const el = e.target.getElement();
								el.classList.remove("active");
							},
						});
					},
				});

				if (p?.popup) geoJsonInstance.bindPopup(p.popup);

				geoJsonInstance.addTo(initMap);
			});
		}

		if (markers) {
			markers.map((m) => {
				if (m.coordinates == null) return;

				let color = "#0b4678";
				if (m.status === true) {
					color = "green";
				} else if (m.status === false) {
					color = "red";
				}

				const markerInstance = marker(m.coordinates, {
					icon: defaultIcon,
				});

				if (m?.popup) {
					const popupContent = `
						<div class="popup-content">
							<p class="popup-text">${m.popup}</p>
							<div class="status">
							<p>${appStore.phrases?.["status"]}:</p>
							<span style="background: ${color};">${m.status ? appStore.phrases?.["completed"] : appStore.phrases?.["not-completed"]}</span>
							</div>
						</div>
					`;
					markerInstance.bindPopup(popupContent);
				}

				markerInstance.addTo(initMap);
			});
		}

		if (onInit != null) onInit(initMap);
	});

	return <div className="map-container" id={mapId}></div>;
}
